import { createSelector } from "@reduxjs/toolkit";

// Base selectors
const selectCategoriesState = state => state.categories;
const selectAuthorsState = state => state.authors;
const selectSubcategoriesState = state => state.subcategories;
const selectChallengesState = state => state.challenges;
const selectSeriesState = state => state.series;
const selectTappingPointsState = state => state.tapping_points;
const selectBackgroundMusicsState = state => state.background_musics;
const selectMediaState = state => state.media;
const selectSessionsState = state => state.sessions;

// Memoized selectors
export const selectCategories = createSelector(
  selectCategoriesState,
  categories => categories?.all_categories || []
);

export const selectAuthors = createSelector(
  selectAuthorsState,
  authors => {
    if (!authors?.authors) return [];
    return authors.authors;
  }
);

export const selectSubcategories = createSelector(
  selectSubcategoriesState,
  subcategories => subcategories?.subcategories || []
);

export const selectChallenges = createSelector(
  selectChallengesState,
  challenges => challenges?.challenges || {}
);

export const selectSeries = createSelector(
  selectSeriesState,
  series => {
    if (!series?.all_series) return [];
    // If it's already an array, return it
    if (Array.isArray(series.all_series)) return series.all_series;
    // If it's an object, convert to array
    return Object.values(series.all_series);
  }
);

export const selectTappingPoints = createSelector(
  selectTappingPointsState,
  tappingPoints => tappingPoints?.tapping_points || []
);

export const selectBackgroundMusics = createSelector(
  selectBackgroundMusicsState,
  backgroundMusics => {
    if (!backgroundMusics?.background_musics) return [];
    return backgroundMusics.background_musics;
  }
);

export const selectMedia = createSelector(
  selectMediaState,
  media => ({
    image: media?.image || '',
    audio: media?.audio || ''
  })
);

export const selectSessions = createSelector(
  selectSessionsState,
  sessions => sessions?.all_sessions || []
); 